import store from './src/store'
const dashboard = () => import('./src/views/dashboard')
const noticebar = () => import('./src/components/noticebar.vue')

const install = (Vue, options) => {
  if (!options.store) {
    throw new Error('Please initialize the VueJS notice bar project with a vuex store.')
  }

  Vue.component('site-noticebar', noticebar)

  return options.store.registerModule('noticebar', store, { preserveState: options.store.state.noticebar !== undefined })
}

export default { install, dashboard }
